import React from 'react';
import { Grid } from "react-bootstrap";
import Slider from "react-slick";
import './Partners.css';

const PARTNERS = [
  { image: "/images/bci_seguros.jpg", name: "BCI Seguros" },
  { image: "/images/Chubb.jpg", name: "Chubb" },
  { image: "/images/consorcio.jpg", name: "Consorcio" },
  { image: "/images/Liberty.jpg", name: "Liberty" },
  { image: "/images/reale.jpg", name: "Reale" }
];

const SLIDER_SETTINGS = {
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  speed: 4000,
  autoplaySpeed: 2000,
  cssEase: "linear",
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3 } },
    { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
    { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1, speed: 1000 } }
  ]
};

export default function Partners() {
  return (
    <section className="partners home-content">
      <Grid>
        <h2>Nuestras alianzas</h2>
        <p className="lead-text">COMPAÑÍAS DE SEGUROS</p>
        <div className="partner-list">
          <Slider {...SLIDER_SETTINGS}>
            {PARTNERS.map(partner => (
              <div key={partner.name} className="img">
                <img src={partner.image} alt={partner.name} className="small img-fluid" />
              </div>
            ))}
          </Slider>
        </div>
      </Grid>
    </section>
  );
}



// WEBPACK FOOTER //
// ./src/components/Partners.js